export default __webpack_public_path__ + "static/media/ennovate_2.147c71dd.jpg";